export default {
    path: 'paihuo',
    component: () => import(/* webpackChunkName: "common-list" */ '@/pages/paihuo/List'),
    meta: {title:'公司审核'},
	children: [
        {
            path: 'company_auth',
            component: () => import('@/pages/paihuo/companyAuth'),
            meta: {
                title: '企业授权'
            },
        },
		{
			path: 'paihuo_project',
			component: () => import('@/pages/paihuo/ProjectList'),
			meta: {
				title: '项目审核'
			},
		},{
			path: 'info',
			component: () => import('@/pages/paihuo/CompanyInfo'),
			meta: {
				title: '公司详情'
			},
		},{
			path: '/paihuo_project/info',
			component: () => import('@/pages/paihuo/ProjectInfo'),
			meta: {
				title: '项目详情'
			},
		},
        {
            path: '/audit_miniapp',
            component: () => import('@/pages/paihuo/auditMiniapp'),
            meta: {
                title: '小程序添加'
            },
        }
	]
}